import { z } from "zod";

const editChildrenSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(50, "Name cannot exceed 50 characters"),
  date_of_birth: z
    .union([z.date(), z.null(),z.string()])  // Allow null values
    .refine(
      (date) => date !== null,    // Check for null and provide custom error message
      { message: "Date of Birth is required" }
    ),
  gender: z.string().min(1, "Gender is required"),
});

export default editChildrenSchema;
